import './index.scss';


import { Rive, EventType, Fit, RiveEventType } from '@rive-app/canvas-lite';

class ContacMap {

    get riveFile() {
        return this.mapContainer.dataset.src;
    }

    get activeRegion() {
        let activeRegions = this.regionSelects
            .filter(region => region.element.classList.contains('active'))
            .map(region => region.action);
        return activeRegions.length > 0 ? activeRegions[0] : 'World';
    }
    registerRiveAnimation() {
        return new Promise((resolve, reject) => {
            this.rive = new Rive({
                canvas: this.mapContainer,
                src: this.riveFile,
                autoplay:true,
                fit: Fit.cover,
                stateMachines: "State Machine 1",
                onLoad: () => {
                    resolve();
                },

            });
        });
    }

    set activeRegion(activeRegion) {
        this.regionSelects.forEach(regionSelect => {
            if (regionSelect.action === activeRegion) {
                regionSelect.element.classList.add('active');
            } else {
                regionSelect.element.classList.remove('active');
            }
        });
        this.updateRegionFilter();
    }

    wireButtons() {
        return new Promise((resolve, reject) => {
            this.rive.stateMachineInputs('State Machine 1').forEach(i => this.riveInputs[i.name.replace("Klick ", "")] = i);
            this.regionSelects.forEach(regionSelect => {
                regionSelect.element.addEventListener('click', (event) => {

                    if (regionSelect.element.classList.contains('active')) {
                        this.riveInputs['World'].fire();
                        this.activeRegion = 'World';
                    } else {
                        this.riveInputs[regionSelect.action].fire();
                        this.activeRegion = regionSelect.action;
                    }

                });
            });
            resolve();
        });
    }

    updateRegionFilter() {
        console.log('update regionFilter', this.activeRegion,this.regions);

        this.regions.forEach(region => {
            if (region.region === this.activeRegion) {
                region.element.classList.add('active');
            } else {
                region.element.classList.remove('active');
            }
        });
    }
    registerListeners() {
        console.log('registerListeners');
        this.rive.on(EventType.RiveEvent, (event) => {
            console.log(event);
           this.activeRegion = event.data.name;
        });

    }
    constructor(root) {
        this.root = root;
        this.mapContainer = this.root.querySelector('.map-container');
        this.regionSelects = Array.from(this.root.querySelectorAll('.region-select button'))
            .map(b => {
                return {
                    element: b,
                    action: b.dataset.action
                }
            });

        this.regions = Array.from(this.root.querySelectorAll('.region-list .region'))
            .map(r => {
                return {
                    element: r,
                    region: r.dataset.region
                }
            });
        this.riveInputs = {};
        console.log('init contact map', this.riveFile, this.mapContainer);
        this.registerRiveAnimation()
            .then(() => {this.rive.resizeDrawingSurfaceToCanvas()})
            .then(() => {this.wireButtons()})
            .then(() => {this.registerListeners()})
            .then(() => {console.log('init complete', this.riveInputs)});


        /*
        this.root.addEventListener('mouseenter', (event) => {
            if (this.rive.animationNames.includes('on')) {
                if (this.rive.isPlaying) {
                    this.rive.stop();
                }

                this.rive.play('on');
            }
        });

        this.root.addEventListener('mouseleave', (event) => {
            if (this.rive.animationNames.includes('off')) {
                if (this.rive.isPlaying) {
                    this.rive.stop();
                }

                this.rive.play('off');
            }
        });
*/
        // window.addEventListener('resize', () => {
        //     this.rive.resizeDrawingSurfaceToCanvas();
        // });
    }
}

window.app.run(() => {
    document.querySelectorAll('.contact-map').forEach((node) => {
        new ContacMap(node);
    });
});
